export default __webpack_public_path__ + "static/media/Present2.f9266361.svg";